var map = {
	"./": 72812,
	"./App": 54111,
	"./App.css": 44050,
	"./App.js": 54111,
	"./App.scss": 33737,
	"./App.test": 55653,
	"./App.test.js": 55653,
	"./assets/audios/puchero.mp3": 78882,
	"./assets/data/boletines": 90898,
	"./assets/data/boletines.js": 90898,
	"./assets/files/activisms.pdf": 25199,
	"./assets/files/articles/mys-nuria.pdf": 52133,
	"./assets/files/boletines/Boletín_01 de junio de 2025.pdf": 48601,
	"./assets/files/boletines/Boletín_01 de marzo de 2026.pdf": 7904,
	"./assets/files/boletines/Boletín_01 de mayo de 2024.pdf": 2289,
	"./assets/files/boletines/Boletín_01 de mayo de 2026.pdf": 55363,
	"./assets/files/boletines/Boletín_02 de agosto de 2026.pdf": 90163,
	"./assets/files/boletines/Boletín_02 de junio de 2026.pdf": 59439,
	"./assets/files/boletines/Boletín_05 de marzo de 2025.pdf": 45875,
	"./assets/files/boletines/Boletín_06 de mayo de 2024.pdf": 28834,
	"./assets/files/boletines/Boletín_08 de marzo de 2026.pdf": 76807,
	"./assets/files/boletines/Boletín_13 de diciembre de 2024.pdf": 31724,
	"./assets/files/boletines/Boletín_15 de julio de 2025.pdf": 15770,
	"./assets/files/boletines/Boletín_16 de mayo de 2024.pdf": 50881,
	"./assets/files/boletines/Boletín_16 de octubre de 2025.pdf": 16662,
	"./assets/files/boletines/Boletín_17 de diciembre de 2025.pdf": 19077,
	"./assets/files/boletines/Boletín_18 de mayo de 2026.pdf": 89957,
	"./assets/files/boletines/Boletín_21 de julio de 2026.pdf": 43302,
	"./assets/files/boletines/Boletín_22 de junio de 2025.pdf": 50214,
	"./assets/files/boletines/Boletín_23 de febrero de 2026.pdf": 11948,
	"./assets/files/boletines/Boletín_27 de marzo de 2024.pdf": 71026,
	"./assets/files/boletines/Boletín_27 de noviembre de 2025.pdf": 61435,
	"./assets/files/boletines/Boletín_28 de mayo de 2026.pdf": 33960,
	"./assets/files/boletines/Boletín_29 de abril de 2026.pdf": 76993,
	"./assets/files/boletines/Boletín_29 de marzo de 2024.pdf": 94092,
	"./assets/files/boletines/Boletín_29 de mayo de 2025.pdf": 80658,
	"./assets/files/boletines/Boletín_9 de febrero de 2026.pdf": 28892,
	"./assets/files/dossier.pdf": 83569,
	"./assets/files/estudio.pdf": 53897,
	"./assets/files/guia.pdf": 58912,
	"./assets/files/indice.pdf": 4318,
	"./assets/files/instancia.pdf": 55564,
	"./assets/files/jornadas.pdf": 86792,
	"./assets/files/justicia.pdf": 85782,
	"./assets/files/maig2022.pdf": 34142,
	"./assets/files/manifiesto.pdf": 2911,
	"./assets/files/objectives.pdf": 72786,
	"./assets/files/posicionamiento-red-internacional.pdf": 28523,
	"./assets/files/programa.pdf": 57779,
	"./assets/files/propuesta_cast.pdf": 54264,
	"./assets/files/propuesta_cat.pdf": 13358,
	"./assets/files/rights.pdf": 50955,
	"./assets/files/salud-menstrual.pdf": 60035,
	"./assets/files/solicitud.pdf": 18024,
	"./assets/img/Fundadoras-madrina.png": 84824,
	"./assets/img/Portada vídeo_Amigas.jpg": 95807,
	"./assets/img/accion-punto-rojo-barcelona-8m-2026.jpeg": 60119,
	"./assets/img/activism-2.png": 90903,
	"./assets/img/activism/Acción en Punto Rojo Barcelona 8M_Marzo 2025.jpg": 67048,
	"./assets/img/activism/Acción en Punto Rojo Barcelona 8M_Marzo 2026.jpeg": 82656,
	"./assets/img/activism/Acción en Punto Rojo Barcelona 8M_Marzo2024.jpeg": 7966,
	"./assets/img/activism/Acción por el Día Mundial de la Menarquia_28 de octubre 2026.jpeg": 74148,
	"./assets/img/activism/Cartel hecho por Rocío Ahumada para el Punto Rojo Barcelona_ Agosto 2025.png": 20270,
	"./assets/img/adhesion-día-internacional-menarquia.png": 37240,
	"./assets/img/adriana-guzman.png": 81669,
	"./assets/img/articles/1.png": 27321,
	"./assets/img/articles/10.png": 66717,
	"./assets/img/articles/11.png": 45588,
	"./assets/img/articles/12.png": 67055,
	"./assets/img/articles/13.png": 85510,
	"./assets/img/articles/14.png": 87929,
	"./assets/img/articles/15.png": 81680,
	"./assets/img/articles/16.svg": 56143,
	"./assets/img/articles/17.svg": 93566,
	"./assets/img/articles/18.svg": 79737,
	"./assets/img/articles/19.svg": 97992,
	"./assets/img/articles/2.png": 71234,
	"./assets/img/articles/20.svg": 94216,
	"./assets/img/articles/21.svg": 6585,
	"./assets/img/articles/28m-dia-internacional-salud-menstrual.jpeg": 70951,
	"./assets/img/articles/3.png": 92363,
	"./assets/img/articles/4.png": 42452,
	"./assets/img/articles/5.png": 75485,
	"./assets/img/articles/7.png": 16943,
	"./assets/img/articles/8.png": 91992,
	"./assets/img/articles/9.png": 13121,
	"./assets/img/articles/Compresas de tela.png": 51838,
	"./assets/img/articles/cuerpo-menopausico-paso-tiempo.png": 54389,
	"./assets/img/articles/cultura-menstrual-elnacional.jpeg": 85664,
	"./assets/img/articles/derechos-menstruales-politicas.jpg": 62920,
	"./assets/img/articles/dia-mundial-menarquia.png": 6317,
	"./assets/img/articles/educacion-menstrual-academico.png": 71078,
	"./assets/img/articles/gaza-higiene-menstrual.png": 65201,
	"./assets/img/articles/menopausia-climaterio.png": 61004,
	"./assets/img/articles/pandemia-ciclo-menstrual.jpeg": 78749,
	"./assets/img/articles/paradigma-ritmos-cuerpo.png": 84204,
	"./assets/img/articles/perimenopausia-experiencia.jpg": 21286,
	"./assets/img/articles/productes-menstruals-reutiltzables.png": 78219,
	"./assets/img/articles/productos-menstruales-gratuitos.png": 69822,
	"./assets/img/campaign-menopausia.png": 43809,
	"./assets/img/colaborators/eva.png": 57544,
	"./assets/img/colaborators/nuria.png": 61195,
	"./assets/img/cultura-menstrual-galeria/Apertura del encuentro con Carolina Ackermann Barreiro_Viernes 31 de mayo de 2019.jpg": 74371,
	"./assets/img/cultura-menstrual-galeria/Cantautora Lidia Uve_Viernes 31 de mayo de 2019.jpg": 50167,
	"./assets/img/cultura-menstrual-galeria/Cierre del encuentro con Diana Pinzón Sanabria_Sábado 01 de junio de 2019.jpg": 88388,
	"./assets/img/cultura-menstrual-galeria/Co-organizadoras 1er EnCuMe.jpg": 87009,
	"./assets/img/cultura-menstrual-galeria/Comida compartida_La Bonne_Sábado 01 de junio de 2019.jpg": 42041,
	"./assets/img/cultura-menstrual-galeria/Cristina de Amba (Menstruacion Digna) en streaming.jpg": 37241,
	"./assets/img/cultura-menstrual-galeria/Dos de las colaboradoras_ Rocío Remuiñan y Mariana Cortéz.jpg": 93114,
	"./assets/img/cultura-menstrual-galeria/Foto grupal asistentes al 1er EnCuMe.jpg": 81938,
	"./assets/img/cultura-menstrual-galeria/Mesa redonda internacional_Sábado 01 de junio de 2019.jpg": 75530,
	"./assets/img/cultura-menstrual-galeria/Ponencia de la Dra. Carme Valls-Llobet_Sábado 01 de junio de 2019.JPG": 48368,
	"./assets/img/cultura-menstrual-galeria/Presentación de compañeras y proyectos.jpg": 89469,
	"./assets/img/cultura-menstrual-galeria/Revistas Mujeres y Salud_CAPS.jpg": 86469,
	"./assets/img/cultura-menstrual-galeria/Toti Baches nos habló de su película.jpg": 32929,
	"./assets/img/cultura-menstrual/Cartel programa 1er EnCuMe.png": 55994,
	"./assets/img/definition-lg.jpeg": 71698,
	"./assets/img/definition-md.jpeg": 83222,
	"./assets/img/definition-sm.jpeg": 87667,
	"./assets/img/dia-internacional-salud-menstrual.jpg": 55304,
	"./assets/img/educadoras-menstruales-mapeo.svg": 58174,
	"./assets/img/encume-md.png": 98153,
	"./assets/img/encume-sm.png": 2914,
	"./assets/img/entidades-colaboradoras/AraGorputz.png": 65766,
	"./assets/img/entidades-colaboradoras/BeArtsy.Clara García.png": 10431,
	"./assets/img/entidades-colaboradoras/Gremi d_artesanes cicliques.jpeg": 27143,
	"./assets/img/entidades-colaboradoras/Igualitarium.png": 67680,
	"./assets/img/entidades-colaboradoras/logo_brotes-principal.webp": 15457,
	"./assets/img/etica-feminista-encuentros-territorio .png": 26972,
	"./assets/img/fanzines/img_fanzine_cm_01.png": 38519,
	"./assets/img/fanzines/img_fanzine_cm_02.png": 49788,
	"./assets/img/fanzines/img_fanzine_cm_03.png": 67301,
	"./assets/img/fanzines/img_fanzine_cm_04.png": 82634,
	"./assets/img/fanzines/img_fanzine_cm_05.png": 33395,
	"./assets/img/formacion-ub/class-2024.jpeg": 40469,
	"./assets/img/formacion-ub/course-2023-2024.png": 54553,
	"./assets/img/formacion-ub/course-2024-2025.png": 68545,
	"./assets/img/formacion-ub/jornadas-2026.png": 3140,
	"./assets/img/founders/Fundadoras-madrina.png": 46805,
	"./assets/img/founders/ana-luisa.jpg": 17754,
	"./assets/img/founders/carolina.png": 84490,
	"./assets/img/founders/junta.png": 7595,
	"./assets/img/founders/victoria.png": 17394,
	"./assets/img/friends/artemeia.png": 26638,
	"./assets/img/friends/atalanta.png": 83658,
	"./assets/img/friends/baubolove.png": 32649,
	"./assets/img/friends/beartsy.png": 71242,
	"./assets/img/friends/ciclicamente.png": 8233,
	"./assets/img/friends/coachin.png": 17051,
	"./assets/img/friends/ginevitex.png": 33179,
	"./assets/img/friends/inteligencia-ciclica.png": 76193,
	"./assets/img/friends/liberando-utopias.png": 96694,
	"./assets/img/friends/menstrualmente-hablando.png": 52114,
	"./assets/img/friends/mujer-ciclica.png": 94448,
	"./assets/img/friends/naturcup.png": 26754,
	"./assets/img/friends/ninssa.png": 89036,
	"./assets/img/friends/nushu.png": 84367,
	"./assets/img/friends/oudoca.png": 82601,
	"./assets/img/friends/rusccus.png": 59440,
	"./assets/img/friends/uterra.png": 67099,
	"./assets/img/friends/wearealltehsametribe.png": 12001,
	"./assets/img/general/Mapeo2026.png": 89959,
	"./assets/img/general/asociacion_img.png": 92692,
	"./assets/img/general/carme-valls-encume.png": 6542,
	"./assets/img/general/definition_img.png": 49604,
	"./assets/img/general/encume-md.png": 93560,
	"./assets/img/general/founders.png": 96263,
	"./assets/img/general/hazte-amiga.png": 67879,
	"./assets/img/general/header_img.png": 12656,
	"./assets/img/hero-alt.jpg": 59970,
	"./assets/img/img-purpose-md.png": 44870,
	"./assets/img/img-purpose.png": 63401,
	"./assets/img/libro/Libro_EM1.png": 58077,
	"./assets/img/libro/Libro_EM2.png": 76870,
	"./assets/img/libro/Portada libro.jpeg": 28973,
	"./assets/img/libro/bookOverview.jpg": 94261,
	"./assets/img/libro/floral.png": 41365,
	"./assets/img/libro/flores_horiz.png": 46741,
	"./assets/img/libro/img1.jpg": 27477,
	"./assets/img/libro/img2.jpg": 35402,
	"./assets/img/libro/img3.jpg": 3143,
	"./assets/img/libro/img4.jpg": 85244,
	"./assets/img/libro/libro_img.png": 77175,
	"./assets/img/libro/logo-icon.png": 68674,
	"./assets/img/logos/logo-blanco-global.png": 81870,
	"./assets/img/logos/logo-blanco.png": 68844,
	"./assets/img/logos/logo-horiz-blanco.png": 72731,
	"./assets/img/logos/logo-horiz.png": 97543,
	"./assets/img/logos/logo-icon.png": 97758,
	"./assets/img/logos/logo.png": 8186,
	"./assets/img/logos/logo_new.png": 5245,
	"./assets/img/logos/manifiesto.png": 11646,
	"./assets/img/manifiesto-palestina.png": 30175,
	"./assets/img/manifiesto.png": 78709,
	"./assets/img/mapa-mundi.png": 68041,
	"./assets/img/materials/derechosmenstruales.png": 82983,
	"./assets/img/materials/portada.png": 82490,
	"./assets/img/nosotras.png": 93453,
	"./assets/img/offer-lg.png": 57880,
	"./assets/img/offer-md.png": 23912,
	"./assets/img/offer.png": 67164,
	"./assets/img/posicionamiento-red.png": 26609,
	"./assets/img/pronunciamiento-solidaridad.png": 53628,
	"./assets/img/rights-hands.png": 2528,
	"./assets/videos/fiesta_menstrual.mp4": 79616,
	"./components/AssociationCampaignPopup": 17452,
	"./components/AssociationCampaignPopup.js": 17452,
	"./components/BackToTop": 10924,
	"./components/BackToTop.js": 10924,
	"./components/CollaborationRequestForm/CollaborationRequestForm": 73236,
	"./components/CollaborationRequestForm/CollaborationRequestForm.js": 73236,
	"./components/CollaborationRequestForm/collaboration-request-form.css": 88023,
	"./components/Footer": 10834,
	"./components/Footer.js": 10834,
	"./components/MemoryItem": 71349,
	"./components/MemoryItem.js": 71349,
	"./components/Navigation": 33517,
	"./components/Navigation.js": 33517,
	"./components/Navigation.test": 98769,
	"./components/Navigation.test.js": 98769,
	"./components/NewsletterCTA": 17262,
	"./components/NewsletterCTA.js": 17262,
	"./components/RRSS": 46423,
	"./components/RRSS.js": 46423,
	"./components/Timeline": 7262,
	"./components/Timeline.js": 7262,
	"./components/article/Article": 44990,
	"./components/article/Article.js": 44990,
	"./components/article/article.css": 10275,
	"./components/back-to-top.css": 86041,
	"./components/fanzine/Fanzine": 54974,
	"./components/fanzine/Fanzine.js": 54974,
	"./components/fanzine/Fanzine.test": 76642,
	"./components/fanzine/Fanzine.test.js": 76642,
	"./components/fanzine/fanzine.css": 48763,
	"./components/friend/Friend": 8880,
	"./components/friend/Friend.js": 8880,
	"./components/friend/friend.css": 87553,
	"./components/memoryItem.scss": 45971,
	"./components/newsletter-cta.css": 62968,
	"./components/screens/activism/photoArchive/ActivismPhotoArchive": 75329,
	"./components/screens/activism/photoArchive/ActivismPhotoArchive.js": 75329,
	"./components/screens/activism/photoArchive/activismPhotoArchive.css": 6128,
	"./components/screens/amigas/beingpart/BeingPart": 5377,
	"./components/screens/amigas/beingpart/BeingPart.js": 5377,
	"./components/screens/amigas/beingpart/beingpart.css": 91496,
	"./components/screens/amigas/whydoit/Whydoit": 16921,
	"./components/screens/amigas/whydoit/Whydoit.js": 16921,
	"./components/screens/amigas/whydoit/whydoit.css": 74376,
	"./components/screens/encume/Encume": 80852,
	"./components/screens/encume/Encume.js": 80852,
	"./components/screens/encume/Rights": 92453,
	"./components/screens/encume/Rights.js": 92453,
	"./components/screens/encume/definition/Definition": 12674,
	"./components/screens/encume/definition/Definition.js": 12674,
	"./components/screens/encume/definition/definition.css": 21949,
	"./components/screens/encume/offer/Offering": 92704,
	"./components/screens/encume/offer/Offering.js": 92704,
	"./components/screens/encume/offer/offering.css": 88081,
	"./components/screens/encume/vallsEncume/VallsEncume": 70422,
	"./components/screens/encume/vallsEncume/VallsEncume.js": 70422,
	"./components/screens/encume/vallsEncume/vallsencume.css": 71837,
	"./components/screens/homescreen/Activism": 8989,
	"./components/screens/homescreen/Activism.js": 8989,
	"./components/screens/homescreen/Activism.test": 83755,
	"./components/screens/homescreen/Activism.test.js": 83755,
	"./components/screens/homescreen/ActivismPillarsAccordion": 17284,
	"./components/screens/homescreen/ActivismPillarsAccordion.js": 17284,
	"./components/screens/homescreen/Education": 24129,
	"./components/screens/homescreen/Education.js": 24129,
	"./components/screens/homescreen/Research": 16382,
	"./components/screens/homescreen/Research.js": 16382,
	"./components/screens/homescreen/activism-pillars-accordion.css": 41107,
	"./components/screens/homescreen/boletines/BoletinesTimeline": 84051,
	"./components/screens/homescreen/boletines/BoletinesTimeline.js": 84051,
	"./components/screens/homescreen/boletines/boletines-timeline.css": 18547,
	"./components/screens/homescreen/conversatorio/Conversatorio": 12528,
	"./components/screens/homescreen/conversatorio/Conversatorio.js": 12528,
	"./components/screens/homescreen/conversatorio/conversatorio.css": 3779,
	"./components/screens/homescreen/header/Header": 1476,
	"./components/screens/homescreen/header/Header.js": 1476,
	"./components/screens/homescreen/header/header.css": 86519,
	"./components/screens/homescreen/home.css": 24889,
	"./components/screens/homescreen/press/Press": 96564,
	"./components/screens/homescreen/press/Press.js": 96564,
	"./components/screens/homescreen/press/press.css": 45183,
	"./components/screens/homescreen/purpose/Collapsible": 16006,
	"./components/screens/homescreen/purpose/Collapsible.js": 16006,
	"./components/screens/homescreen/purpose/InterventionAxes": 60232,
	"./components/screens/homescreen/purpose/InterventionAxes.js": 60232,
	"./components/screens/homescreen/purpose/InterventionAxes.test": 93344,
	"./components/screens/homescreen/purpose/InterventionAxes.test.js": 93344,
	"./components/screens/homescreen/purpose/MenstrualCultureDefinition": 12142,
	"./components/screens/homescreen/purpose/MenstrualCultureDefinition.js": 12142,
	"./components/screens/homescreen/purpose/MenstrualCultureDefinition.test": 84178,
	"./components/screens/homescreen/purpose/MenstrualCultureDefinition.test.js": 84178,
	"./components/screens/homescreen/purpose/Purpose": 8868,
	"./components/screens/homescreen/purpose/Purpose.js": 8868,
	"./components/screens/homescreen/purpose/Purpose.test": 98852,
	"./components/screens/homescreen/purpose/Purpose.test.js": 98852,
	"./components/screens/homescreen/purpose/collapsible.css": 99801,
	"./components/screens/homescreen/purpose/intervention-axes.css": 39834,
	"./components/screens/homescreen/purpose/menstrual-culture-definition.css": 25135,
	"./components/screens/homescreen/purpose/purpose.css": 16247,
	"./components/screens/homescreen/red/Red": 36628,
	"./components/screens/homescreen/red/Red.js": 36628,
	"./components/screens/homescreen/red/red.css": 55527,
	"./components/screens/homescreen/research/Research": 24392,
	"./components/screens/homescreen/research/Research.js": 24392,
	"./components/screens/homescreen/research/research.css": 14559,
	"./components/screens/libro/bookForYou/BookForYou": 93687,
	"./components/screens/libro/bookForYou/BookForYou.js": 93687,
	"./components/screens/libro/bookForYou/bookforyou.css": 40884,
	"./components/screens/libro/bookHero/BookHero": 56843,
	"./components/screens/libro/bookHero/BookHero.js": 56843,
	"./components/screens/libro/bookHero/bookHero.css": 54880,
	"./components/screens/libro/bookOverview/BookOverview": 87829,
	"./components/screens/libro/bookOverview/BookOverview.js": 87829,
	"./components/screens/libro/bookOverview/bookoverview.css": 36986,
	"./components/screens/libro/bookStructure/BookStructure": 53171,
	"./components/screens/libro/bookStructure/BookStructure.js": 53171,
	"./components/screens/libro/bookStructure/bookStructure.css": 48132,
	"./components/screens/libro/collectiveWork/CollectiveWork": 75915,
	"./components/screens/libro/collectiveWork/CollectiveWork.js": 75915,
	"./components/screens/libro/collectiveWork/collectivework.css": 72616,
	"./components/screens/libro/components/Gallery": 78375,
	"./components/screens/libro/components/Gallery.js": 78375,
	"./components/screens/libro/contributors/Contributors": 62241,
	"./components/screens/libro/contributors/Contributors.js": 62241,
	"./components/screens/libro/contributors/contributors.css": 83882,
	"./components/screens/libro/freeDownload/FreeDownload": 33525,
	"./components/screens/libro/freeDownload/FreeDownload.js": 33525,
	"./components/screens/libro/freeDownload/freeDownload.css": 77622,
	"./components/screens/libro/keyThinkers/KeyThinkers": 40651,
	"./components/screens/libro/keyThinkers/KeyThinkers.js": 40651,
	"./components/screens/libro/keyThinkers/keyThinkers.css": 37468,
	"./components/screens/libro/menstrualEducation/MenstrualEducation": 83087,
	"./components/screens/libro/menstrualEducation/MenstrualEducation.js": 83087,
	"./components/screens/libro/menstrualEducation/menstrualeducation.css": 79428,
	"./components/screens/libro/menstrualEducationWhy/MenstrualEducationWhy": 75787,
	"./components/screens/libro/menstrualEducationWhy/MenstrualEducationWhy.js": 75787,
	"./components/screens/libro/menstrualEducationWhy/menstrualeducationwhy.css": 91452,
	"./components/screens/libro/photoArchive/PhotoArchive": 20925,
	"./components/screens/libro/photoArchive/PhotoArchive.js": 20925,
	"./components/screens/libro/photoArchive/photoArchive.css": 68938,
	"./components/screens/menstrual-culture/MenstrualCultureDefinition": 79756,
	"./components/screens/menstrual-culture/MenstrualCultureDefinition.js": 79756,
	"./components/screens/menstrual-culture/MenstrualCultureDefinition.test": 50764,
	"./components/screens/menstrual-culture/MenstrualCultureDefinition.test.js": 50764,
	"./components/screens/menstrual-culture/MenstrualCultureEncumePoster": 93053,
	"./components/screens/menstrual-culture/MenstrualCultureEncumePoster.js": 93053,
	"./components/screens/menstrual-culture/MenstrualCultureGallery": 45975,
	"./components/screens/menstrual-culture/MenstrualCultureGallery.js": 45975,
	"./components/screens/menstrual-culture/MenstrualCultureHero": 5145,
	"./components/screens/menstrual-culture/MenstrualCultureHero.js": 5145,
	"./components/screens/menstrual-culture/Testimonies": 526,
	"./components/screens/menstrual-culture/Testimonies.js": 526,
	"./components/screens/menstrual-culture/menstrual-culture-definition.css": 76375,
	"./components/screens/menstrual-culture/menstrual-culture-encume-poster.css": 20037,
	"./components/screens/menstrual-culture/menstrual-culture-hero.css": 77404,
	"./components/screens/menstrual-culture/testimonies.css": 2455,
	"./components/screens/publications/articles/PublicationsArticles": 84955,
	"./components/screens/publications/articles/PublicationsArticles.js": 84955,
	"./components/screens/publications/articles/publications-articles.css": 84495,
	"./components/screens/publications/book/PublicationsBook": 44207,
	"./components/screens/publications/book/PublicationsBook.js": 44207,
	"./components/screens/publications/book/publications-book.css": 4047,
	"./components/screens/publications/fanzines/PublicationsFanzines": 24357,
	"./components/screens/publications/fanzines/PublicationsFanzines.js": 24357,
	"./components/screens/publications/fanzines/publications-fanzines.css": 65099,
	"./components/screens/publications/hero/PublicationsHero": 69541,
	"./components/screens/publications/hero/PublicationsHero.js": 69541,
	"./components/screens/publications/hero/publications-hero.css": 61027,
	"./components/screens/publications/manifestos/PublicationsManifesters": 41785,
	"./components/screens/publications/manifestos/PublicationsManifesters.js": 41785,
	"./components/screens/publications/manifestos/publications-manifestos.css": 89311,
	"./components/screens/quienessomos/Colaborators": 74880,
	"./components/screens/quienessomos/Colaborators.js": 74880,
	"./components/screens/quienessomos/Founders": 70189,
	"./components/screens/quienessomos/Founders.js": 70189,
	"./components/screens/quienessomos/friends/Friends": 54518,
	"./components/screens/quienessomos/friends/Friends.js": 54518,
	"./components/screens/quienessomos/friends/friends.css": 82793,
	"./components/screens/quienessomos/us/Us": 45696,
	"./components/screens/quienessomos/us/Us.js": 45696,
	"./components/screens/quienessomos/us/us.css": 88703,
	"./components/subHeading/SubHeading": 7252,
	"./components/subHeading/SubHeading.js": 7252,
	"./components/subHeading/subHeading.css": 721,
	"./components/timeline.scss": 26432,
	"./containers": 30917,
	"./containers/": 30917,
	"./containers/index": 30917,
	"./containers/index.js": 30917,
	"./containers/navigation/Navigation": 55660,
	"./containers/navigation/Navigation.jsx": 55660,
	"./containers/navigation/navigation.css": 81645,
	"./index": 72812,
	"./index.css": 59555,
	"./index.js": 72812,
	"./mocks/articleContents": 59459,
	"./mocks/articleContents.json": 59459,
	"./mocks/articles": 43726,
	"./mocks/articles.json": 43726,
	"./mocks/fanzines": 67051,
	"./mocks/fanzines.json": 67051,
	"./mocks/friends": 64434,
	"./mocks/friends.json": 64434,
	"./mocks/memories": 11033,
	"./mocks/memories.json": 11033,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./screens/ActivismPage": 19521,
	"./screens/ActivismPage.js": 19521,
	"./screens/ActivismPage.test": 56555,
	"./screens/ActivismPage.test.js": 56555,
	"./screens/Articles": 77763,
	"./screens/Articles.js": 77763,
	"./screens/AxesPage": 99582,
	"./screens/AxesPage.js": 99582,
	"./screens/AxesPage.test": 33762,
	"./screens/AxesPage.test.js": 33762,
	"./screens/BookDescriptionEN": 45724,
	"./screens/BookDescriptionEN.js": 45724,
	"./screens/EducationPage": 51819,
	"./screens/EducationPage.js": 51819,
	"./screens/EducationPage.test": 5865,
	"./screens/EducationPage.test.js": 5865,
	"./screens/Encume": 4789,
	"./screens/Encume.js": 4789,
	"./screens/Friends": 91111,
	"./screens/Friends.js": 91111,
	"./screens/Friends.test": 50253,
	"./screens/Friends.test.js": 50253,
	"./screens/HomeScreen": 74319,
	"./screens/HomeScreen.js": 74319,
	"./screens/HomeScreen.test": 57621,
	"./screens/HomeScreen.test.js": 57621,
	"./screens/Libro": 62122,
	"./screens/Libro.js": 62122,
	"./screens/Memories": 89099,
	"./screens/Memories.js": 89099,
	"./screens/MenstrualCulturePage": 44448,
	"./screens/MenstrualCulturePage.js": 44448,
	"./screens/PrivacyPolicy": 19320,
	"./screens/PrivacyPolicy.js": 19320,
	"./screens/Publications": 38607,
	"./screens/Publications.js": 38607,
	"./screens/QuienesSomos": 11985,
	"./screens/QuienesSomos.js": 11985,
	"./screens/RedPage": 72070,
	"./screens/RedPage.js": 72070,
	"./screens/RedPage.test": 51978,
	"./screens/RedPage.test.js": 51978,
	"./screens/ResearchPage": 52894,
	"./screens/ResearchPage.js": 52894,
	"./screens/ResearchPage.test": 82754,
	"./screens/ResearchPage.test.js": 82754,
	"./screens/UbTrainingPage": 42602,
	"./screens/UbTrainingPage.js": 42602,
	"./screens/UbTrainingPage.test": 83366,
	"./screens/UbTrainingPage.test.js": 83366,
	"./screens/WhatWeDoPage": 12152,
	"./screens/WhatWeDoPage.js": 12152,
	"./screens/WhatWeDoPage.test": 9936,
	"./screens/WhatWeDoPage.test.js": 9936,
	"./screens/activism-page.css": 32619,
	"./screens/article/ArticleDetail": 71920,
	"./screens/article/ArticleDetail.js": 71920,
	"./screens/article/article-detail.css": 63476,
	"./screens/articles.css": 57016,
	"./screens/association-popup.css": 59713,
	"./screens/associationCampaign": 75031,
	"./screens/associationCampaign.js": 75031,
	"./screens/associationCampaign.test": 59965,
	"./screens/associationCampaign.test.js": 59965,
	"./screens/axes-page.css": 32600,
	"./screens/book-description-en.css": 23883,
	"./screens/education-page.css": 84487,
	"./screens/fullPhotoArchive/FullPhotoArchive": 53145,
	"./screens/fullPhotoArchive/FullPhotoArchive.js": 53145,
	"./screens/fullPhotoArchive/fullPhotoArchive.css": 32016,
	"./screens/memories.scss": 23167,
	"./screens/publications.css": 10592,
	"./screens/red-page.css": 53770,
	"./screens/research-page.css": 24276,
	"./screens/ub-training-page.scss": 97932,
	"./screens/what-we-do-page.css": 61128,
	"./styles/commons/colors.scss": 7102,
	"./styles/commons/text.scss": 91541,
	"./styles/encume/definition.styles.scss": 50412,
	"./styles/encume/encume.styles.scss": 44500,
	"./styles/encume/rights.styles.scss": 49166,
	"./styles/footer.styles.scss": 48866,
	"./styles/homescreen/activism.styles.scss": 80735,
	"./styles/homescreen/education.styles.scss": 77121,
	"./styles/homescreen/press.style.scss": 26529,
	"./styles/homescreen/purpose.styles.scss": 27213,
	"./styles/homescreen/research.styles.scss": 85018,
	"./styles/navigation.styles.scss": 96789,
	"./styles/quienessomos/founders.styles.scss": 76951,
	"./styles/rrss.styles.scss": 505,
	"./utilities/ScrollToTop": 69108,
	"./utilities/ScrollToTop.js": 69108,
	"./utilities/articles": 95300,
	"./utilities/articles.js": 95300,
	"./utilities/articles.test": 14308,
	"./utilities/articles.test.js": 14308,
	"./utilities/slugify": 116,
	"./utilities/slugify.js": 116,
	"./utilities/useWindowSize": 94641,
	"./utilities/useWindowSize.js": 94641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;